import React from 'react';
import PropTypes from 'prop-types';
import { FeatureContainer, TileContainer, CardTitle, ArticleImage, ArticleContent, CardDescription, TextContent, ReadingTime } from './FeaturedArticle.styles';
import AuthorSection from '../AuthorSection';
import event from '../../../../utils/analytics/event';
import useGhostActions from '../../../../store/ghost/hooks/useGhostActions';
export var FeaturedArticle = function FeaturedArticle(_ref) {
  var domain = _ref.domain,
      article = _ref.article,
      piwikEvent = _ref.piwikEvent,
      fonts = _ref.fonts,
      colors = _ref.colors,
      ghostApi = _ref.ghostApi,
      hideAuthor = _ref.hideAuthor;

  var _useGhostActions = useGhostActions(ghostApi),
      selectArticle = _useGhostActions.selectArticle;

  var selectedTileClick = function selectedTileClick() {
    window.scroll(0, 0);
    selectArticle(article.slug);
    event(piwikEvent || ['click', 'article-item', article.slug]);
  };

  var longtitle = article.title.length > 70;
  return /*#__PURE__*/React.createElement(FeatureContainer, {
    colors: colors
  }, /*#__PURE__*/React.createElement(TileContainer, {
    href: domain + "/articles/" + article.slug,
    onClick: selectedTileClick,
    colors: colors,
    fonts: fonts
  }, /*#__PURE__*/React.createElement(ArticleContent, {
    colors: colors
  }, /*#__PURE__*/React.createElement(TextContent, null, /*#__PURE__*/React.createElement(CardTitle, {
    fonts: fonts,
    colors: colors,
    longtitle: longtitle
  }, article.title), /*#__PURE__*/React.createElement(ReadingTime, {
    colors: colors,
    fonts: fonts
  }, article.reading_time === 0 ? 1 : article.reading_time, " min read"), /*#__PURE__*/React.createElement(AuthorSection, {
    article: article,
    colors: colors,
    fonts: fonts,
    featured: true,
    hideAuthor: hideAuthor
  }), /*#__PURE__*/React.createElement(CardDescription, {
    fonts: fonts,
    colors: colors
  }, article.excerpt.length > 150 ? article.excerpt.substr(0, 150) + "..." : article.excerpt)), /*#__PURE__*/React.createElement(ArticleImage, {
    src: article.feature_image,
    alt: article.title
  }))));
};
FeaturedArticle.propTypes = {
  /** The initialized Ghost Content API: https://ghost.org/docs/api/v3/javascript/content/#working-example */
  ghostApi: PropTypes.object,

  /** The domain that the article links to */
  domain: PropTypes.string,

  /** The article object that gets passed down from ghost */
  article: PropTypes.object,

  /** Optional piwik event that fires when the article is clicked */
  piwikEvent: PropTypes.array,

  /** Optional object that contains various colors that can be applied to the articles view */
  colors: PropTypes.object,

  /** Optional object that contains fonts that you can apply to the articles view */
  fonts: PropTypes.object,
  hideAuthor: PropTypes.bool
};
export default FeaturedArticle;